import React from 'react';
import ReactView from "shared/react_view";
import Overview from 'connect_apps/shared/Overview';
/*
  TODO: This file should be removed when the facebook connect app is converted to Webpacker
 */

export default class GeneralInfoPanel extends ReactView {
  get className() {
    return 'col-12';
  }

  constructor(model) {
    const {
      last_account_sync: integratedOn,
      sync_initiated_by: integratedBy,
      auth_status: status
    } = model.attributes;

    const props = {
      integrationName: "Facebook Ads",
      integratedBy,
      integratedOn,
      status
    };

    super(<Overview {...props} />);
  }
}
